const Skip = () => <a href="#main-main" id="header-main__skip" className="header-main__skip">Skip to content</a>

export default Skip;
